<template>
  <div class="calc_method" v-if="isHomework"
    :class="{ abacus: calcMethod !== 'oral', small: isSmallFont, wide: isAbacusMode }">

    <img src="../../../assets/oral_counting_2.png" class="oral-img" v-if="calcMethod === 'oral'" />

    <Abacus :notResetOnDestroy="isAbacusMode" :readOnly="isAbacusMode" v-else />
  </div>
</template>

<script>
import Abacus from './Abacus.vue';

export default {
  name: 'calc-mode',

  props: ['calcMethod', 'isHomework', 'isSmallFont', 'isAbacusMode'],

  components: { Abacus }
}
</script>

<style lang="scss">
.oral-img {
  width: 100px;
  height: auto;
}

.abacus {
  width: 160px;

  &.wide {
    width: 400px;
  }
}

.calc_method {
  position: relative;

  padding: 10px 40px;

  min-width: 290px;

  background-color: #fff;

  margin: auto;

  margin-bottom: 20px;

  border: 2px solid rgba(#e4467b, 0.5);
  border-radius: 8px;

  & .abacus {
    width: 160px;
  }
}
</style>